import { useTranslation } from "react-i18next";
import { positionnements } from "../Utils/Listings";
import MultiSelector from "./MultiSelector";

const EditPositionnement = (props) => {
    const { i18n } = useTranslation('common');
    return (
        <MultiSelector {...props} valuesListing={positionnements} label={i18n.language === "fr" ? "Positionnement" : "Positioning"} />
    );
}

export default EditPositionnement;